<template>
  <b-modal ref="modal" :hide-footer="true">
    <template slot="modal-header">
      <h1>Select Track type</h1>

      <div>
        <Button :empty="true" class="close-popup" @click.prevent="hide">{{ Translations.buttons.cancel }}</Button>
        <Button :empty="false" :noBorder="true" class="validate" @click.prevent="updateTypes">Done</Button>
      </div>
    </template>

    <template>
      <div class="flex-container">
        <div class="search-result">
          <div v-for="type in types" :key="`modal-field-${type.value}`" v-on:click="toggleType(type)" class="label-container">
            <i :class="`far fa${isSelected(type) ? '-check' : ''}-square`"></i>
            <span class="name"><strong>{{type.text}}</strong></span>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import Bootstrap from 'bootstrap-vue';
  import Button from '../common/Button';
  import Constants from '../../store/constants';
  import Translations from '../../store/translations';

  export default {
    name: 'SelectorField',
    components: { Button },
    computed: {
      Constants: () => Constants,
      Translations: () => Translations,
      types() {
        const types = [];

        for (var prop in Constants.trackTypes) {
          if (Object.prototype.hasOwnProperty.call(Constants.trackTypes, prop)) {
            types.push(Constants.trackTypes[prop]);
          }
        }
        // remove some fields
        return types.filter(e => e.key !== 'PROMO' && e.key !== 'VOICE_TRACK' && e.key !== 'FILLER')
      }
    },
    data() {
      return {
        selectedTypes: []
      }
    },
    methods: {
      show(field) {
        this.$refs.modal.show();
      },
      hide() {
        this.$refs.modal.hide();
      },
      edit(types) {
        this.selectedTypes = types;
        this.show();
      },
      toggleType(type) {
        const index = this.selectedTypes.indexOf(type);

        if (index >= 0) {
          this.selectedTypes.splice(index, 1);
          return;
        }
        if(!Array.isArray(this.selectedTypes)){
          this.selectedTypes = [];
          this.selectedTypes.push(type);
        } else {
          this.selectedTypes.push(type);
        }
      },
      updateTypes() {
        this.$emit('newValue', 'type', this.selectedTypes);
        this.hide();
      },
      isSelected(type) {
        const selected = this.selectedTypes && this.selectedTypes.filter(t => {
          return t.value === type.value;
        });

        return selected.length > 0;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    cursor: pointer;
    border-radius: 4px;
    padding: 7px;
  }

  .no-result-container header {
      padding: 20px 25px;
  }

  .name {
    width: 100%;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 1em;
    transition: color .2s ease-in-out;
  }

  .modal .modal-content div.flex-container {
    display: flex;
    flex-direction: column;
    margin: -15px;
    width: calc(100% + 30px);
    height: calc(100% + 30px);
  }

  .search-result {
    padding: 15px;
    height: auto;
    overflow: auto;
    max-height: calc(100vh - 200px);
  }
</style>
